// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UserTooltip-cls1__fe69a0118116d25928af{/*!*/}.UserTooltip-cls2___3b88c5e61d659e80ab3{--size: 56px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "UserTooltip-cls1__fe69a0118116d25928af",
	"cls2": "UserTooltip-cls2___3b88c5e61d659e80ab3 UserTooltip-cls1__fe69a0118116d25928af"
};
export default ___CSS_LOADER_EXPORT___;
